import { AUDIT_FIELDS_FLAT } from './audit_fields'

export const ANIMAL_FIELDS_FLAT = [
	{
		field: '_id',
		label: 'ID',
		nofilter: true, // TODO ObjectId, filter must be augmented on server
		readonly: true
	},
	{
		field: 'animalBirthDate',
		label: 'Birth date',
		type: 'date'
	},
	{
		field: 'animalBreed',
		label: 'Breed',
		type: 'enum',
		values: '/listofbreeds:animalType',
		label_key: 'name_en'
	},
	{
		field: 'animalChipID',
		label: 'Chip ID',
		type: 'number'
	},
	{
		field: 'animalHairLength',
		label: 'Hair length',
		type: 'enum',
		values: [
			'short',
			'medium',
			'long',
			'unknown'
		]
	},
	{
		field: 'animalName',
		label: 'Name'
	},
	{
		field: 'animalNeutered',
		label: 'Neutered',
		type: 'enum',
		values: [
			'neutered',
			'not_neutered',
			'unknown'
		]
	},
	{
		field: 'ownerName',
		label: 'Owner\'s name'
	},
	{
		field: 'animalSex',
		label: 'Sex',
		type: 'enum',
		values: [
			'female',
			'male',
			'unknown'
		]
	},
	{
		field: 'animalType',
		label: 'Type',
		type: 'enum',
		values: [
			'cat',
			'dog',
			'horse',
			'human',
			'not_animal',
			'other',
			'pig',
			'wolf',
			'cattle'
		]
	},
	{
		field: 'animalWeight',
		label: 'Weight',
		type: 'number'
	},
	{
		field: 'external_resource_link',
		label: 'External Resource Link',
		type: 'link'
	},
	{
		field: 'comment',
		label: 'Comment',
	}
]

export const ANIMAL_LISTED_FIELDS_FLAT = [
	...ANIMAL_FIELDS_FLAT,
	...AUDIT_FIELDS_FLAT
]
